import { useCallback, useRef } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.bearing-intelligence.com';
const SESSION_KEY = 'bi_session_id';

function getSessionId() {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = Math.random().toString(36).slice(2, 18);
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

function getDeviceUUID() {
  let uuid = localStorage.getItem('bi_device_uuid');
  if (!uuid) {
    uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0;
      return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
    });
    localStorage.setItem('bi_device_uuid', uuid);
  }
  return uuid;
}

export function useAnalytics() {
  const sessionId = useRef(getSessionId());
  const deviceUUID = useRef(getDeviceUUID());
  const lastEvent = useRef({});

  const track = useCallback((event_type, properties = {}) => {
    const key = `${event_type}:${JSON.stringify(properties)}`;
    const now = Date.now();
    if (lastEvent.current[key] && now - lastEvent.current[key] < 2000) return;
    lastEvent.current[key] = now;

    fetch(`${API_URL}/api/analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        device_uuid: deviceUUID.current,
        event_type,
        properties,
        session_id: sessionId.current
      })
    }).catch(() => {});
  }, []);

  return { track };
}
